/**
 * Shared UI JS libraries. Use only what we need to keep the vendor file size smaller.
 */
require('@wpmudev/shared-ui/dist/js/_src/modals');
require('@wpmudev/shared-ui/dist/js/_src/a11y-dialog');
require('@wpmudev/shared-ui/dist/js/_src/notifications');
require('@wpmudev/shared-ui/dist/js/_src/scores');
require('@wpmudev/shared-ui/dist/js/_src/select');
require('@wpmudev/shared-ui/dist/js/_src/tabs');
require('@wpmudev/shared-ui/dist/js/_src/upload'); // Used on lazy load page (since 3.2.2).
require('@wpmudev/shared-ui/dist/js/_src/reviews');
